<template>
  <div>
    <div v-if="loading" class="text-center py-2">
      <BSpinner variant="primary" />
    </div>
    <table
      v-else-if="reviewsHistory.length"
      role="table"
      class="table b-table table-striped table-hover my-2 status-history-table"
    >
      <thead role="rowgroup" class="">
        <tr role="row">
          <th>Review status</th>
          <th>Final status</th>
          <th>Created by</th>
          <th>Assigned to</th>
          <th>Reassigned to</th>
          <th>Comment</th>
          <th>Protected Completes</th>
          <th>Protected Payouts</th>
          <th>Created at</th>
          <th>Assigned at</th>
          <th>OC</th>
          <th>TIC</th>
          <th>Pattern Risk</th>
          <th>Median TCP Latency</th>
          <th>Median WS Latency</th>
          <th>Median Latency Delta</th>
        </tr>
      </thead>
      <tbody role="rowgroup">
        <tr v-for="(log, index) in reviewsHistory" :key="log.uuid">
          <td class="text-left">
            <div class="d-flex align-items-center">
              <BBadge :class="[`user-status-${log.user_status} mr-1`]">
                {{ statusText(log.user_status) }}
              </BBadge>
              
              <BBadge class="user-status-2" v-if="log.user_status === 2 && log.ban_indefinite">
                Indefinite
              </BBadge>

              <BBadge class="user-status-4" v-else-if="log.user_status === 2 && !log.ban_indefinite && log.ban_expire">
                {{ log.ban_expire | dotDateShort }}
              </BBadge>
            </div>
          </td>
          <td class="text-left">
            <BBadge
              v-if="log.user_status_after_review !== null && log.user_status_after_review !== undefined"
              :class="[`user-status-${log.user_status_after_review}`]"
            >
              {{ statusText(log.user_status_after_review) }}
            </BBadge>
            <span v-else>-</span>
          </td>
          <td class="text-left">
            <span
              v-if="log.creator_admin && log.creator_admin.name"
            >
              {{ log.creator_admin.name }}
            </span>
            <span v-else>System</span>
          </td>
          <td class="text-left">
            <span
              v-if="log.admin && log.admin.name"
            >
              {{ log.admin.name }}
            </span>
            <span v-else>-</span>
          </td>
          <td class="text-left">
            <span
              v-if="log.reassigned_to_admin && log.reassigned_to_admin.name"
            >
              {{ log.reassigned_to_admin.name }}
            </span>
            <span v-else>-</span>
          </td>
          <td class="text-left">
            <span v-if="log.comment">
              {{ log.comment }}
            </span>
            <span v-else>-</span>
          </td>
          <td class="text-left">
            <span v-if="log.protected_completes">
              {{ log.protected_completes }}
            </span>
            <span v-else>-</span>
          </td>
          <td class="text-left">
            <span v-if="log.protected_payout">
              {{ log.protected_payout }}
            </span>
            <span v-else>-</span>
          </td>
          <td class="text-left">
            <span v-if="log.created_at">
              {{ log.created_at | dotDateTime}}
            </span>
            <span v-else>-</span>
          </td>
          <td class="text-left">
            <span v-if="log.assigned_at">
              {{ log.assigned_at | dotDateTime}}
            </span>
            <span v-else>-</span>
          </td>
          <td class="text-left text-nowrap" :class="log.oc ? classForOC(log.oc, prevLog(index) ? prevLog(index).oc : undefined) : ''">
            <span v-if="log.oc">{{ log.oc | percentageRound }}</span>
            <span v-else>-</span>
          </td>
          <td class="text-left text-nowrap" :class="log.tic ? classForTIC(log.tic, prevLog(index) ? prevLog(index).tic : undefined) : ''">
            <span v-if="log.tic">{{ log.tic | percentageRound }}</span>
            <span v-else>-</span>
          </td>
          <td class="text-left text-nowrap" :class="log.pattern_risk && Object.values(log.pattern_risk).length ? classForPatternRisk(log.pattern_risk, prevLog(index) ? prevLog(index).pattern_risk : null) : ''">
            <span v-if="log.pattern_risk && Object.values(log.pattern_risk).length">{{ formattedPatternRisk(log.pattern_risk) }}</span>
            <span v-else>No result</span>
          </td>
          <td class="text-left text-nowrap" :class="log.median_tcp_latency !== null && log.median_tcp_latency !== undefined ? classForMedianTcpLatency(log.median_tcp_latency, prevLog(index) ? prevLog(index).median_tcp_latency : undefined) : ''">
            <span v-if="log.median_tcp_latency !== null && log.median_tcp_latency !== undefined">{{ log.median_tcp_latency | round2Decimal }} ms</span>
            <span v-else>-</span>
          </td>
          <td class="text-left text-nowrap" :class="log.median_ws_latency !== null && log.median_ws_latency !== undefined ? classForMedianWsLatency(log.median_ws_latency, prevLog(index) ? prevLog(index).median_ws_latency : undefined) : ''">
            <span v-if="log.median_ws_latency !== null && log.median_ws_latency !== undefined">{{ log.median_ws_latency | round2Decimal }} ms</span>
            <span v-else>-</span>
          </td>
          <td class="text-left text-nowrap" :class="log.median_latency_delta !== null && log.median_latency_delta !== undefined ? classForMedianLatencyDelta(log.median_latency_delta, prevLog(index) ? prevLog(index).median_latency_delta : undefined) : ''">
            <span v-if="log.median_latency_delta !== null && log.median_latency_delta !== undefined">{{ log.median_latency_delta | round2Decimal }} ms</span>
            <span v-else>-</span>
          </td>
        </tr>
      </tbody>
    </table>
    <div v-else>There are no reviews</div>
  </div>
</template>

<script>
import { mapState, mapActions, mapMutations } from 'vuex'
import { BBadge } from 'bootstrap-vue'

export default {
  name: 'UserStatusLogModalContentNew',
  components: {
    BBadge
  },
  props: {
    userId: {
      type: Number,
      required: true
    }
  },
  data () {
    return {
      loading: false,
      statusData: {
        1: {
          text: 'Active'
        },
        2: {
          text: 'Banned'
        },
        3: {
          text: 'Shadow-Banned'
        },
        4: {
          text: 'Review'
        },
        5: {
          text: 'Shadow Review'
        },
        6: {
          text: 'On Hold'
        }
      }
    }
  },
  watch: {
    userId: {
      handler (val) {
        if (val) {
          this.handleGetReviewsHistory()
        }
      },
      immediate: true
    }
  },
  computed: {
    ...mapState('support', {
      reviewsHistory: (state) => state.reviewsHistory
    }),
    isDisabled () {
      return this.loadingSelect || this.loading
    }
  },
  methods: {
    ...mapActions({
      getReviewsHistory: 'support/getReviewsHistory'
    }),
    ...mapMutations({
      SET_REVIEWS_HISTORY: 'support/SET_REVIEWS_HISTORY'
    }),
    prevLog (index) {
      return this.reviewsHistory[index + 1] || null
    },
    statusText (status) {
      return this.statusData[status]?.text || `Unknown (${status ?? '-'})`
    },
    classForOC (value, prevValue) {
      if (value === null || value === undefined) return ''
      if (prevValue !== null && prevValue !== undefined) {
        const delta = parseFloat(value) - parseFloat(prevValue)
        if (delta <= 0) return 'bg-success text-white'
        if (delta <= 0.05) return 'bg-warning text-white'
        return 'bg-danger text-white'
      }
      const v = parseFloat(value)
      if (v < 0.1) return 'bg-success text-white'
      if (v <= 0.25) return 'bg-warning text-white'
      return 'bg-danger text-white'
    },
    classForTIC (value, prevValue) {
      if (value === null || value === undefined) return ''
      if (prevValue !== null && prevValue !== undefined) {
        const delta = parseFloat(value) - parseFloat(prevValue)
        if (delta <= 0) return 'bg-success text-white'
        if (delta <= 0.05) return 'bg-warning text-white'
        return 'bg-danger text-white'
      }
      const v = parseFloat(value)
      if (v < 0.85) return 'bg-success text-white'
      if (v <= 0.9) return 'bg-warning text-white'
      return 'bg-danger text-white'
    },
    classForPatternRisk (pr, prevPr) {
      if (!pr || !Object.values(pr).length || pr.total === null) return ''
      if (prevPr && Object.values(prevPr).length) {
        const curr = parseFloat(pr.banned_percentage || 0) * 100
        const prev = parseFloat(prevPr.banned_percentage || 0) * 100
        const delta = curr - prev
        if (delta <= 0) return 'bg-success text-white'
        if (delta <= 5) return 'bg-warning text-white'
        return 'bg-danger text-white'
      }
      const totalPct = parseFloat(pr.banned_percentage || 0) * 100
      const pct24h = parseFloat(pr.banned_percentage_24h || 0) * 100
      if (totalPct <= 10 && pct24h <= 10) return 'bg-success text-white'
      if (totalPct >= 25 || pct24h >= 25) return 'bg-danger text-white'
      if (totalPct >= 10 || pct24h >= 10) return 'bg-warning text-white'
      return ''
    },
    formattedPatternRisk (pr) {
      if (!pr) return '-'
      const total = pr.banned_percentage ?? 0
      const pct24h = pr.banned_percentage_24h ?? 0
      const totalStr = `${(total * 100).toFixed(1)}%`
      const pct24hStr = `${(pct24h * 100).toFixed(1)}%`
      let result = `${totalStr} (24h: ${pct24hStr})`
      if (total * 100 <= 2 && pct24h * 100 <= 2) result += ' ⭐'
      return result
    },
    classForMedianTcpLatency (value, prevValue) {
      if (value === null || value === undefined) return ''
      if (prevValue !== null && prevValue !== undefined) {
        const delta = parseFloat(value) - parseFloat(prevValue)
        if (delta <= 0) return 'bg-success text-white'
        if (delta <= 50) return 'bg-warning text-white'
        return 'bg-danger text-white'
      }
      const v = parseFloat(value)
      if (v < 100) return 'bg-success text-white'
      if (v <= 300) return 'bg-warning text-white'
      return 'bg-danger text-white'
    },
    classForMedianWsLatency (value, prevValue) {
      if (value === null || value === undefined) return ''
      if (prevValue !== null && prevValue !== undefined) {
        const delta = parseFloat(value) - parseFloat(prevValue)
        if (delta <= 0) return 'bg-success text-white'
        if (delta <= 50) return 'bg-warning text-white'
        return 'bg-danger text-white'
      }
      const v = parseFloat(value)
      if (v < 100) return 'bg-success text-white'
      if (v <= 300) return 'bg-warning text-white'
      return 'bg-danger text-white'
    },
    classForMedianLatencyDelta (value, prevValue) {
      if (value === null || value === undefined) return ''
      if (prevValue !== null && prevValue !== undefined) {
        const delta = parseFloat(value) - parseFloat(prevValue)
        if (delta <= 0) return 'bg-success text-white'
        if (delta <= 20) return 'bg-warning text-white'
        return 'bg-danger text-white'
      }
      const v = parseFloat(value)
      if (v < 0) return ''
      if (v < 40) return 'bg-success text-white'
      if (v <= 60) return 'bg-warning text-white'
      return 'bg-danger text-white'
    },
    async handleGetReviewsHistory () {
      this.SET_REVIEWS_HISTORY([])
      if (!this.userId) return

      try {
        this.loading = true
        await this.getReviewsHistory({ userId: this.userId })
      } catch (e) {
        console.error(e)
      } finally {
        this.loading = false
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.status-history-table {
  thead th {
    position: sticky;
    top: 0;
    z-index: 2;
    box-shadow: inset 0 -2px 0 #ebe9f1;
  }
}

body.dark-layout .status-history-table thead th {
  box-shadow: inset 0 -2px 0 #3b4253;
}
</style>
